var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"justify-center":"","mb-3":""}},[_c('span',{staticClass:"grey--text text-center textoAjustado",staticStyle:{"font-size":"19px"},attrs:{"xs2":""}},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }